import axios from "axios";
import { apiURL } from "../../../apirest/getAPIURL";

const url = (path) => `${apiURL}/bling${path}`;

// URL que inicia o OAuth com o Bling (abre numa aba nova; o callback grava o token).
export const blingAuthorizeUrl = () => url("/oauth/authorize");

export async function fetchBlingStatus() {
  const response = await axios.get(url("/status"));
  return response.data;
}

export async function fetchBlingConfig() {
  const response = await axios.get(url("/config"));
  return response.data;
}

export async function saveBlingConfig(config) {
  const response = await axios.put(url("/config"), config);
  return response.data;
}

export async function fetchNaturezasOperacao() {
  const response = await axios.get(url("/naturezas"));
  return response.data;
}

// Envia um lote de produtos novos/alterados (limit = tamanho do lote).
// Retorna { results, errors, remaining }.
export async function syncPendingProducts(limit) {
  const response = await axios.post(
    url("/sync/products"),
    limit ? { limit } : {},
  );
  return response.data;
}

// Reconcilia o estoque (site → Bling) de um lote de produtos a partir do cursor.
// Retorna { processed, updated, resynced, errors, next, remaining }.
export async function syncStock(after = null, limit) {
  const body = {};
  if (after) body.after = after;
  if (limit) body.limit = limit;
  const response = await axios.post(url("/sync/stock"), body);
  return response.data;
}

// Estado fiscal atual do pedido (inclui a etapa da emissão em andamento).
export async function fetchNfeState(orderId) {
  const response = await axios.get(url(`/nfe/${orderId}`));
  return response.data;
}

// Emite (ou retoma) a NF-e do pedido. Retorna o estado fiscal atualizado.
export async function emitNfe(orderId) {
  const response = await axios.post(url(`/nfe/${orderId}/emit`));
  return response.data;
}

// Consulta a situação na SEFAZ de uma NF-e já transmitida.
export async function refreshNfe(orderId) {
  const response = await axios.post(url(`/nfe/${orderId}/refresh`));
  return response.data;
}

// Mensagem de erro legível vinda da API ({ error }) ou do axios.
export function errorMessage(err) {
  return (
    err?.response?.data?.error ||
    err?.response?.data?.message ||
    err?.message ||
    "Erro inesperado"
  );
}
